export const initialDisplay = (phase, toolName) => ({ phase, toolName });
